/* eslint-disable class-methods-use-this */
class CollectionHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.descriptionText = this.querySelector('div#description p');
    this.readMoreButton = this.querySelector('#read_more_button');

    this.readMoreButton.addEventListener('click', () => {
      this.toggleDescriptionExpansion();
    });

    this.updateReadMoreVisibility();

    this.handleResize = this.debounce(() => {
      if (this.readMoreButton.getAttribute('aria-expanded') == 'true') {
        this.toggleDescriptionExpansion();
      }
      this.updateReadMoreVisibility();
    }, 150);

    window.addEventListener('resize', this.handleResize);
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.handleResize);
  }

  debounce(func, wait) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }

  updateReadMoreVisibility() {
    const clampedHeight = this.descriptionText.clientHeight;
    const fullHeight = this.descriptionText.scrollHeight;

    if (clampedHeight < fullHeight) {
      this.readMoreButton.style.display = 'block';
    } else {
      this.readMoreButton.style.display = 'none';
    }
  }

  toggleDescriptionExpansion() {
    if (this.readMoreButton.getAttribute('aria-expanded') != 'true') {
      this.readMoreButton.setAttribute('aria-expanded', 'true');
    } else {
      this.readMoreButton.setAttribute('aria-expanded', 'false');
    }

    this.readMoreButton.textContent =
      this.readMoreButton.getAttribute('aria-expanded') == 'true' ? 'Read less' : 'Read more';
  }
}

if (!customElements.get('collection-header')) {
  window.customElements.define('collection-header', CollectionHeader);
}
